import { UserSettingsContainer } from "../../../../pages/Settings/AccountDetails/AccountDetails.styled";
import {
  PasswordInput,
  Select,
  SelectItem,
  Text,
  TextInput,
} from "@mantine/core";
import { useFormContext } from "react-hook-form";
import { Grid } from "@mantine/core";
import { Flex } from "../../../../styled";

interface Props {
  providers: SelectItem[];
  watch: (name: string) => any;
}

const NMEACredentials = ({ providers, watch }: Props) => {
  const { register, setValue } = useFormContext();
  const provider = watch("data.providerID");
  return (
    <Grid.Col span={1}>
      <UserSettingsContainer style={{ flexDirection: "column", padding: 20 }}>
        <Text mb={15}>Credentials</Text>
        <Flex direction="column" gap={10}>
          <Select
            key={provider}
            {...register("data.providerID")}
            label="Provider"
            value={providers.length === 0 ? "" : provider}
            onChange={v => setValue("data.providerID", v)}
            data={providers}
          />
          <TextInput {...register("data.imo")} label="IMO Number" />
          <PasswordInput
            {...register("data.clientID")}
            label="Client ID"
            autoComplete="new-password"
          />
          <PasswordInput
            {...register("data.clientSecret")}
            label="Client Secret"
            autoComplete="new-password"
          />
          <PasswordInput
            {...register("data.subKey")}
            label="Subscription Key"
            autoComplete="new-password"
          />
        </Flex>
      </UserSettingsContainer>
    </Grid.Col>
  );
};
export default NMEACredentials;
